import { createFileRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { ComingSoon } from "@/components/marketing/ComingSoon";

export const Route = createFileRoute("/industries")({
  component: IndustriesPage,
});

function IndustriesPage() {
  return (
    <>
      <Helmet>
        {/*
          Noindexed while this is a placeholder. The page returns 200 and has a
          self-canonical, so without this it is indexable - and a "coming soon"
          stub in search results is worse than no result. Remove when the page
          has real content. The VITE_SHOW_* flag only hides it from the nav; it
          does not stop a crawler reaching it.
        */}
        <meta name="robots" content="noindex,follow" />
        <title>Industries | Larasoft</title>
        <meta
          name="description"
          content="Larasoft serves retail, finance, hospitality and more with automated data sync solutions."
        />
        <link rel="canonical" href="https://larasoft.global/industries" />
      </Helmet>
      <ComingSoon pageName="Industries" />
    </>
  );
}
